require('./Resources/js/angular/module');


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/index.js